export default __webpack_public_path__ + "static/media/spongebob.c52f9031.webp";